
import { defineComponent, PropType } from 'vue'
import { AgentAction, AgentActionStatus } from '~/types/types'
import { formatDate, formatSeconds, parseISODate } from '~/utils/date'

export default defineComponent({
  name: 'AgentActionCard',
  props: {
    action: {
      type: Object as PropType<AgentAction>,
      required: true
    }
  },
  computed: {
    AgentActionStatus() {
      return AgentActionStatus
    },
    formatActionDate() {
      return formatDate(parseISODate(this.action?.createdAt), 'lll')
    },
    loopStatusText() {
      if (this.action?.finishedIn && this.action?.status === AgentActionStatus.Completed) {
        return `Agent loop completed in ${formatSeconds(this.action?.finishedIn)}.`
      }
      if (this.action?.status === AgentActionStatus.Pending) {
        return 'Agent loop is still running...'
      }
      return null
    }
  }
})
